import { ConfigProvider, ThemeConfig } from "antd";
import { PropsWithChildren, ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { antLocales } from "../../../translations";

export interface AntDesignThemeProviderProps {
  theme: ThemeConfig;
}

export default function AntDesignThemeProvider({ children, theme }: PropsWithChildren<AntDesignThemeProviderProps>): ReactElement {
  const { i18n } = useTranslation();

  return (
    // hardcoded light theme because Genesys Cloud does not yet support dark mode (they have it planned, ref: https://help.mypurecloud.com/dashboard-ui-updates/)
    <ConfigProvider theme={theme} locale={antLocales[i18n.language]}>
      {children}
    </ConfigProvider>
  );
}
